import {lazy,Suspense} from "react";
import { Route, Routes } from "react-router-dom";
import { Layout } from "./components/Layout";
import { HomePage } from "./pages/HomePage";
const ListingsPage=lazy(()=>import("./pages/ListingsPage").then(m=>({default:m.ListingsPage})));
const PropertyDetailPage=lazy(()=>import("./pages/PropertyDetailPage").then(m=>({default:m.PropertyDetailPage})));
const AboutPage=lazy(()=>import("./pages/AboutPage").then(m=>({default:m.AboutPage})));
const ContactPage=lazy(()=>import("./pages/ContactPage").then(m=>({default:m.ContactPage})));
const GalleryPage=lazy(()=>import("./pages/GalleryPage").then(m=>({default:m.GalleryPage})));
const InformationPage=lazy(()=>import("./pages/InformationPage").then(m=>({default:m.InformationPage})));
import { NotFoundPage } from "./pages/NotFoundPage";

export default function App() {
  return (
    <Suspense fallback={<div className="container section" role="status">Loading…</div>}><Routes>
      <Route element={<Layout />}>
        <Route index element={<HomePage />} />
        <Route path="properties" element={<ListingsPage />} />
        <Route path="property/:slug" element={<PropertyDetailPage />} />
        <Route path="gallery" element={<GalleryPage />} />
        {["terms", "privacy", "cookies", "buying-guide"].map(path => <Route key={path} path={path} element={<InformationPage />} />)}
        <Route path="about" element={<AboutPage />} />
        <Route path="contact" element={<ContactPage />} />
        <Route path="404" element={<NotFoundPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes></Suspense>
  );
}
